'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawers = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _pushCartActions = require('../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _listeners = require('../../utils/listeners');

var _functional = require('../../utils/functional');

var _images = require('../../utils/images');

var _utils = require('../../utils');

var _drawer = require('./drawer');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var matches = {
  trigger: '[data-module-drawers-trigger]',
  triggerIcon: '[data-module-drawers-trigger-icon]',
  close: '[data-module-drawers-close]',
  backdrop: '.js-Drawers_Backdrop'
};
var els = {
  body: document.body || document.documentElement,
  backdrop: (0, _functional.getElement)(matches.backdrop),
  drawers: (0, _functional.getElement)('.drw-Drawers'),
  header: (0, _functional.getElement)('.js-Header'),
  headerSearchTrigger: (0, _functional.getElement)('.js-HeaderSearch_Trigger'),
  headerSearch: (0, _functional.getElement)('.js-HeaderSearch'),
  mobileNavColumns: (0, _functional.getElements)('.js-MobileNav_Column')
};
var classes = {
  activeClass: 'drw-Drawers-active',
  activeDrawerClass: 'drw-Drawer-active',
  siteOverflowed: 'util-SiteOverflowed',
  posFixed: 'util-PosFixed',
  openedClass: 'drw-Drawers-opened',
  searchActive: 'hd-Header_Search-active'
};
var options = {
  openOneAtATime: true
};

var Drawers = exports.Drawers = {
  init: function init() {
    var _this = this;

    var keys = (0, _functional.getElements)('[data-module-drawers-trigger]').map(function (el) {
      return el.dataset.moduleDrawersTrigger;
    });

    var drawers = keys.map(function (key) {
      return _this.createDrawer(key);
    });

    this.keys = keys;
    this.drawers = drawers;
    this.listeners = new _listeners.Listeners();
    this.handleClick = this.handleClick.bind(this);

    this.setupListeners();
  },

  createDrawer: function createDrawer(key) {
    var drawer = (0, _create2.default)(_drawer.Drawer);
    drawer.init({ key: key });

    return drawer;
  },

  setupListeners: function setupListeners() {
    this.listeners.add(els.body, 'click', this.handleClick);
  },

  handleClick: function handleClick(event) {
    var target = event.target;

    var isTrigger = target.closest(matches.trigger) !== null;
    var isClose = target.closest(matches.close) !== null;
    var isBackdrop = target.closest(matches.backdrop) !== null;
    var shouldReturnEarly = isTrigger === false && isClose === false && isBackdrop === false;

    if (shouldReturnEarly) return;
    event.preventDefault();

    if (isTrigger) {
      var trigger = target.closest(matches.trigger);
      var key = trigger.dataset.moduleDrawersTrigger;

      if (this.keys.includes(key)) {
        this.activeDrawerKey = key === this.activeDrawerKey ? '' : key;
      } else {
        this.drawers.push(this.createDrawer(key));
      }
    }

    if (isClose || isBackdrop) {
      this.activeDrawerKey = '';
    }
  },

  get activeDrawerKey() {
    return this._activeDrawerKey;
  },

  set activeDrawerKey(key) {
    var _this2 = this;

    var previousKey = this._activeDrawerKey;
    this._activeDrawerKey = key;
    // Set header to fixed to avoid conflict with body o

    var elementsToHideWhenADrawerIsOpen = (0, _functional.getElements)('[data-hide-me-when-a-drawer-is-open]');

    elementsToHideWhenADrawerIsOpen.forEach(function (element) {
      element.setAttribute('aria-hidden', (key !== '').toString());
    });

    // Swap header hamburger icon for close icon if menu drawer is open
    var triggerIcon = (0, _functional.getElement)(matches.triggerIcon);

    if (triggerIcon) {
      if (key === 'menu') {
        triggerIcon.classList.toggle('am-icon-burger');
        triggerIcon.classList.toggle('am-icon-close-thin');
      } else {
        triggerIcon.classList.remove('am-icon-close-thin');
        triggerIcon.classList.add('am-icon-burger');
      }
    }

    if (key === 'cart') {
      var openCart = new Event('open_cart');
      document.dispatchEvent(openCart);
    }

    if (key === '') {
      this.drawers.forEach(function (d) {
        return d.isOpen = false;
      });
    } else {
      var drawer = this.drawers.find(function (d) {
        return d.key === _this2._activeDrawerKey;
      });
      var drawerEl = drawer.els.drawer;
      drawer.isOpen = true;

      if (options.openOneAtATime) {
        this.drawers.filter(function (d) {
          return d.key !== _this2._activeDrawerKey;
        }).forEach(function (d) {
          return d.isOpen = false;
        });
      }

      // Lazy load all images inside a drawer after it opens
      if (!drawerEl.classList.contains(classes.openedClass)) {
        drawerEl.classList.add(classes.openedClass);
        (0, _images.loadImages)('.lazyload-drawers', drawerEl, 'lazyload-drawers');
      }

      // Hides the search bar if its opened
      if (els.headerSearch && els.headerSearch.classList.contains(classes.searchActive)) {
        els.headerSearchTrigger.click();
      }
    }

    var allDrawersAreClosed = this.drawers.every(function (d) {
      return d.isOpen === false;
    });
    els.drawers.classList.toggle(classes.activeClass, !allDrawersAreClosed);
    els.drawers.dataset.activeDrawer = key;
    document.documentElement.classList.toggle(classes.siteOverflowed, !allDrawersAreClosed);
    els.header.classList.toggle(classes.posFixed, !allDrawersAreClosed);

    if (previousKey === 'menu') {
      if (allDrawersAreClosed) {
        setTimeout(function () {
          els.mobileNavColumns.forEach(function (element) {
            element.setAttribute('aria-expanded', 'false');
          });
        }, 500);
      }
    }

    if (previousKey === 'cart') {
      window.store.dispatch(pushCartActions.removeAllErrors());
    }

    if ((0, _utils.mediaBreakpointMatches)('xs')) {
      (0, _functional.lockScroll)(!!key);
    }
  }
};